import {AppStore, setUser} from "../../useAppPullState";
import {useCallback} from "react";
import {firebaseService} from "../../service/firebase";

export const useLogout = () => {
    const {
        authUser,
    } = AppStore.useState(s => ({
        authUser: s.authUser,
    }))

    return useCallback(() => {
        setUser(null);
        firebaseService.signOut();
        AppStore.update(s => {
            s.menuOpen = false;
            s.loginPage = true;
        });
    }, [authUser])
}
